export const FORCE_DISCONNECTED_EVENT = 'force_disconnected';
export const GAME_STATE_UPDATED = 'game_state_updated';
export const INTERNAL_CONNECTION_EVENT = 'connection';
export const INTERNAL_DISCONNECT_EVENT = 'disconnect';
export const INTERNAL_ERROR_EVENT = 'error';
export const PLAYER_DISCONNECTED_EVENT = 'player_disconnected';
export const PLAYER_JOINED_EVENT = 'player_joined';
export const PLAYER_VOTED_EVENT = 'player_voted';
export const PRESENTER_CHANGED_PLAYER_NAME_EVENT =
  'presenter_changed_player_name';
export const PRESENTER_DISCONNECTED_EVENT = 'presenter_disconnected';
export const PRESENTER_MARKED_ANSWER_EVENT = 'presenter_marked_answer';
export const QUIZ_COUNTDOWN_STARTED_EVENT = 'quiz_countdown_started';
export const QUIZ_CREATED_EVENT = 'quiz_created';
export const QUIZ_ENDED_EVENT = 'quiz_ended';
export const QUIZ_STARTED_EVENT = 'quiz_started';
export const TIME_SYNC_CONNECT_EVENT = 'connect';
export const TIME_SYNC_DISCONNECT_EVENT = 'disconnect';

export const ALL_EVENTS = [
  FORCE_DISCONNECTED_EVENT,
  GAME_STATE_UPDATED,
  INTERNAL_CONNECTION_EVENT,
  INTERNAL_DISCONNECT_EVENT,
  INTERNAL_ERROR_EVENT,
  PLAYER_DISCONNECTED_EVENT,
  PLAYER_JOINED_EVENT,
  PLAYER_VOTED_EVENT,
  PRESENTER_CHANGED_PLAYER_NAME_EVENT,
  PRESENTER_DISCONNECTED_EVENT,
  PRESENTER_MARKED_ANSWER_EVENT,
  QUIZ_COUNTDOWN_STARTED_EVENT,
  QUIZ_CREATED_EVENT,
  QUIZ_ENDED_EVENT,
  QUIZ_STARTED_EVENT,
  TIME_SYNC_CONNECT_EVENT,
  TIME_SYNC_DISCONNECT_EVENT,
] as const;
